module.exports = __webpack_public_path__ + "static/media/folder_icon.77509578.svg";